module.exports = __webpack_public_path__ + "img/Flag_of_Bhutan (1).ce4684f2.svg";